module.exports = __webpack_public_path__ + "img/profile-woman-3-min.9294a21a.jpg";